import React from "react";

import { Button, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";

import { ReactComponent as SMALogo } from "../../../assets/svgs/smalogo.svg";

interface ResetPasswordSubmittedForTabletsProps {}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        margin: 0,
    },
    buttonContainer: {
        marginTop: 6,
    },
    button: {
        marginTop: 6,
        minWidth: 165,
        backgroundColor: '#FFB500',
        color: '#013270',
        borderRadius: 30,
        '&:hover': {
            color: '#0049a3',
            backgroundColor: '#013270',
        },
    },
    logo: {
        maxWidth: 180,
        width: "100%",
        maxHeight: 162,
        cursor: "pointer",
      },
    contentContainer: {
        maxWidth: 1280,
        margin: 'auto',
        width: "100%",
        backgroundColor: '#001630',
        backgroundImage: 'url(https://smalive.wisdom.com.au/app/uploads/2021/06/bg-overlay-03-1.jpg)',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minHeight: '100vh'
    },

    headerBody: {
        padding: 25,
        display: 'flex',
    },
    headerLogin: {
        marginTop: 30,
        paddingBottom: 0
    },
    topLabelText: {
        color: '#ffffff',
        marginBottom: 12,
        fontSize: 36,
        maxWidth: 540
    },
    infoText: {
        color: '#ffffff',
        marginBottom: 12,
        opacity: 0.75,
        fontSize: 21,
        maxWidth: 540
    },
}));

const ResetPasswordSubmittedForTablets: React.FC<ResetPasswordSubmittedForTabletsProps> = () => {
  const classes = useStyles();
  const history = useHistory();

  const backToLogin = () => {
    history.push("/login");
  };

  return (
    <div className={classes.root}>
      <div className={classes.contentContainer}>
        <Grid className={classes.headerBody} container>
          <Grid item xs={12} sm={4}>
            <SMALogo className={classes.logo} onClick={backToLogin} />
          </Grid>
          <Grid item xs={12} sm={8} className={classes.headerLogin}>
            <Grid container>
              <Grid item xs={12}>
                <div className={classes.topLabelText}>Check your email!</div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.infoText}>We just sent instructions for resetting your password. Remember to check your spam folder too.</div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.buttonContainer}>
                  <Button className={classes.button} variant="contained" onClick={backToLogin}>
                    Back to Login
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default React.memo(ResetPasswordSubmittedForTablets);
